import { IComment } from "interfaces/comment";
import { useReadComments } from "hooks/comments/useReadComments";

interface Result {
  loading: boolean;
  getEventComments: () => Promise<IComment[]>;
}

export function useReadEventComments(eventId: number): Result {
  const { loading, getComments } = useReadComments(`events/${eventId}`);

  return {
    loading,
    getEventComments: getComments
  };
}
